<template>
  <div class="special-gifts page--padding">
    <special-gifts-intro />
    <special-gifts-trust-us />
    <special-gifts-solutions />
    <special-gifts-contacts />
  </div>
</template>

<script>
import SpecialGiftsIntro from "@/views/SpecialGifts/special-gifts-intro.vue";
import SpecialGiftsTrustUs from "@/views/SpecialGifts/special-gifts-trust-us.vue";
import SpecialGiftsSolutions from "@/views/SpecialGifts/special-gifts-solutions.vue";
import SpecialGiftsContacts from "@/views/SpecialGifts/special-gifts-contacts.vue";

export default {
  name: 'SpecialGifts',
  components: {SpecialGiftsContacts, SpecialGiftsSolutions, SpecialGiftsTrustUs, SpecialGiftsIntro}
}
</script>

<style lang="scss">
.special-gifts {}
</style>